<template>
  <div class="container-fluid align-items-center top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop">
        <div class="col-lg-4">
          <div class="card">
            <v-card tile>
              <v-row>
                <v-list-item>
                  <v-list-item-avatar size="70">
                    <img
                      src="https://www.w3schools.com/howto/img_avatar.png"
                      alt="John"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="title" style="margin-top:20px;">{{
                      user.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      user.profile.address || "Update"
                    }}</v-list-item-subtitle>
                    <v-divider></v-divider>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content class="p-2 mb-4">
                    <v-list-item-subtitle class="ml-2"
                      >Info:
                    </v-list-item-subtitle>
                    <div>
                      <v-chip class="mr-2">
                        <v-icon left> mdi-brightness-5 </v-icon>
                        Email: {{ user.email }}
                      </v-chip>

                      <v-chip class="mr-2">
                        <v-icon left> mdi-brightness-5 </v-icon>
                        Phone: {{ user.profile.phone }}
                      </v-chip>

                      <v-chip class="mr-2">
                        <v-icon left> mdi-brightness-5 </v-icon>
                        Role: {{ user.roles[0].name }}
                      </v-chip>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-row>
            </v-card>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="card z-depth-3">
            <div class="card-body">
              <ul class="nav nav-pills nav-pills-primary nav-justified">
                <li class="nav-item">
                  <a
                    href=""
                    data-target="#profile"
                    data-toggle="pill"
                    class="nav-link active show"
                    ><i class="icon-user"></i>
                    <span class="hidden-xs">Documents</span></a
                  >
                </li>
              </ul>
              <div class="tab-content p-3">
                <div class="tab-pane active show" id="profile">
                  <v-simple-table fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Document Name
                          </th>

                          <th class="text-left">
                            Last Updated
                          </th>

                          <th class="text-left">
                            Updated By
                          </th>

                          <th class="text-left">
                            Actions
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="doc in docs.submissions" :key="doc.id">
                          <td>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">{{
                                  doc.doc_name.name
                                }}</span>
                              </template>
                              <span>{{ doc.doc_name.description }}</span>
                            </v-tooltip>
                          </td>
                          <td>
                            <small class="text-danger">
                              {{ formatDate(doc.updated_at) }}</small
                            >
                            <!-- <div v-for="update in doc.updates" :key="update.id">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on"
                                    ><b>User:</b> {{ update.user_name }} <br />
                                    <b>Date: </b>
                                    {{ formatDate(update.updated_at) }}</span
                                  >
                                </template>
                                <span> {{ update.changes_notes }} </span>
                              </v-tooltip>
                            </div> -->
                          </td>

                          <td>
                            <v-chip small>{{ doc.author.name }} </v-chip>
                          </td>

                          <td>
                            <v-btn
                              v-if="
                                doc.file_name == null &&
                                  doc.json_data.length > 2
                              "
                              x-small
                              rounded
                              color="#2196F3"
                              @click="openDocument(doc)"
                              dark
                            >
                              Edit Document</v-btn
                            >

                            <v-btn
                              v-else-if="doc.file_name !== null"
                              x-small
                              rounded
                              color="#2196F3"
                              @click="openDocument2(doc)"
                              dark
                            >
                              Edit Document</v-btn
                            >

                            <v-btn
                              v-else
                              x-small
                              rounded
                              color="#E1BEE7"
                              target="_blank"
                              :href="url2 + doc.document_name"
                            >
                              View Document</v-btn
                            >

                            <template v-if="roleUser === 'admin'">
                              <v-btn
                                x-small
                                rounded
                                class="ml-2 text-dark"
                                @click="completeDocument(doc)"
                                color="#C6FF00"
                                dark
                              >
                                Mark as Complete</v-btn
                              >
                              <v-chip
                                color="#4CAF50"
                                @click="getPdf(doc)"
                                class="ml-2 text-white"
                              >
                                Download
                              </v-chip>
                            </template>
                            <template v-else>
                              <!-- v-if="doc.status == 'Pending'" -->
                              <v-chip
                                v-if="
                                  doc.file_name == null &&
                                    doc.json_data.length > 2
                                "
                                small
                                color="#607D8B"
                                class="ml-2 text-white"
                              >
                                {{ doc.status }}
                              </v-chip>

                              <v-btn
                                x-small
                                v-if="doc.file_name"
                                target="_blank"
                                :href="url + doc.file_name"
                                rounded
                                class="ml-2"
                                color="#E91E63"
                                dark
                              >
                                Download</v-btn
                              >
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
                <div class="tab-pane" id="messages">
                  <div class="alert alert-info alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert">
                      ×
                    </button>
                    <div class="alert-icon">
                      <i class="icon-info"></i>
                    </div>
                    <div class="alert-message">
                      <span
                        ><strong>Info!</strong> Recieve message from Armando
                      </span>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="edit"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end of the auth user  -->
    </div>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <dialog-update
        @update="getDocuments"
        @clicked="closeDocModalFinal"
        :singleDoc="singleDoc"
      ></dialog-update>
    </v-dialog>

    <v-dialog
      v-if="dialog2"
      v-model="dialog2"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <dialog-create
        @update="getDocuments"
        @clicked="closeDocModal"
        :singleDoc="singleDoc"
      ></dialog-create>
    </v-dialog>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import DialogUpdate from "./DialogUpdate";
import DialogCreate from "./DialogCreate";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    DialogCreate,
    DialogUpdate
  },

  data() {
    return {
      dialog: false,
      dialog2: false,
      selected: false,
      name: "",
      description: "",
      document: [],
      docs: [],
      singleDoc: "",
      url: process.env.VUE_APP_API_URL_FILES,
      url2: process.env.VUE_APP_API_URL_S3,

      valid: false,
      form: {
        name: "",
        email: "",
        password: ""
      },
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 12 || "Name must be less than 12 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => v.length >= 8 || "Password must be have 8 characters at least"
      ]
    };
  },

  computed: {
    ...mapGetters({
      user: "userLogin",
      roleUser: "userRole"
    })
  },

  created() {
    this.getDocuments();
  },

  methods: {
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },

    updateSubmission(submission) {
      var queryString = $("#myFormId2").serializeArray(); // store json object

      window.axios
        .post("/api/updateSubmission/" + submission.id, {
          queryString: queryString
        })
        .then(() => {
          //$("#selectDay").modal("hide");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Form data succesfully sent, Waiting for aprove",
            showConfirmButton: false,
            timer: 1500
          });
          this.getDocuments();
        });
    },

    getPdf(doc) {
      window.axios.get("/api/getPdf/" + doc.id).then(() => {
        // this.getDocuments();
      });
    },

    completeDocument(doc) {
      window.axios.post("/api/completedDoc/" + doc.id).then(() => {
        this.getDocuments();
      });
    },

    closeDocModal() {
      this.dialog2 = false;
      this.singleDoc = "";
      this.getDocuments();
    },

    closeDocModalFinal() {
      this.dialog = false;
      this.singleDoc = "";
      this.getDocuments();
    },

    openDocument(doc) {
      this.singleDoc = doc;
      this.dialog2 = true;
      // this.dialog2 = !this.dialog2;
      //$("#selectDay").modal("show");
    },

    openDocument2(doc) {
      this.singleDoc = doc;
      this.dialog = true;
      // $("#selectDay").modal("show");
    },

    getDocuments() {
      window.axios.get("/api/userDocs").then(response => {
        this.docs = response.data;
      });
    }
  }
};
</script>

<style scoped>
/* User Cards */
.user-box {
  width: 110px;
  margin: auto;
  margin-bottom: 20px;
}

.user-box img {
  width: 100%;
  border-radius: 50%;
  padding: 3px;
  background: #fff;
  -webkit-box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
  -ms-box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}

.profile-card-2 .card {
  position: relative;
}

.profile-card-2 .card .card-body {
  z-index: 1;
}

.profile-card-2 .card::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  height: 112px;
  background-color: #e6e6e6;
}

.profile-card-2 .card.profile-primary::before {
  background-color: #008cff;
}
.profile-card-2 .card.profile-success::before {
  background-color: #15ca20;
}
.profile-card-2 .card.profile-danger::before {
  background-color: #fd3550;
}
.profile-card-2 .card.profile-warning::before {
  background-color: #ff9700;
}
.profile-card-2 .user-box {
  margin-top: 30px;
}

.profile-card-3 .user-fullimage {
  position: relative;
}

.profile-card-3 .user-fullimage .details {
  position: absolute;
  bottom: 0;
  left: 0px;
  width: 100%;
}

.profile-card-4 .user-box {
  width: 110px;
  margin: auto;
  margin-bottom: 10px;
  margin-top: 15px;
}

.profile-card-4 .list-icon {
  display: table-cell;
  font-size: 30px;
  padding-right: 20px;
  vertical-align: middle;
  color: #223035;
}

.profile-card-4 .list-details {
  display: table-cell;
  vertical-align: middle;
  font-weight: 600;
  color: #223035;
  font-size: 15px;
  line-height: 15px;
}

.profile-card-4 .list-details small {
  display: table-cell;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 400;
  color: #808080;
}

/*Nav Tabs & Pills */
.nav-tabs .nav-link {
  color: #223035;
  font-size: 12px;
  text-align: center;
  letter-spacing: 1px;
  font-weight: 600;
  margin: 2px;
  margin-bottom: 0;
  padding: 12px 20px;
  text-transform: uppercase;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover {
  border: 1px solid transparent;
}
.nav-tabs .nav-link i {
  margin-right: 2px;
  font-weight: 600;
}

.top-icon.nav-tabs .nav-link i {
  margin: 0px;
  font-weight: 500;
  display: block;
  font-size: 20px;
  padding: 5px 0;
}

.nav-tabs-primary.nav-tabs {
  border-bottom: 1px solid #008cff;
}

.nav-tabs-primary .nav-link.active,
.nav-tabs-primary .nav-item.show > .nav-link {
  color: #008cff;
  background-color: #fff;
  border-color: #008cff #008cff #fff;
  border-top: 3px solid #008cff;
}

.nav-tabs-success.nav-tabs {
  border-bottom: 1px solid #15ca20;
}

.nav-tabs-success .nav-link.active,
.nav-tabs-success .nav-item.show > .nav-link {
  color: #15ca20;
  background-color: #fff;
  border-color: #15ca20 #15ca20 #fff;
  border-top: 3px solid #15ca20;
}

.nav-tabs-info.nav-tabs {
  border-bottom: 1px solid #0dceec;
}

.nav-tabs-info .nav-link.active,
.nav-tabs-info .nav-item.show > .nav-link {
  color: #0dceec;
  background-color: #fff;
  border-color: #0dceec #0dceec #fff;
  border-top: 3px solid #0dceec;
}

.nav-tabs-danger.nav-tabs {
  border-bottom: 1px solid #fd3550;
}

.nav-tabs-danger .nav-link.active,
.nav-tabs-danger .nav-item.show > .nav-link {
  color: #fd3550;
  background-color: #fff;
  border-color: #fd3550 #fd3550 #fff;
  border-top: 3px solid #fd3550;
}

.nav-tabs-warning.nav-tabs {
  border-bottom: 1px solid #ff9700;
}

.nav-tabs-warning .nav-link.active,
.nav-tabs-warning .nav-item.show > .nav-link {
  color: #ff9700;
  background-color: #fff;
  border-color: #ff9700 #ff9700 #fff;
  border-top: 3px solid #ff9700;
}

.nav-tabs-dark.nav-tabs {
  border-bottom: 1px solid #223035;
}

.nav-tabs-dark .nav-link.active,
.nav-tabs-dark .nav-item.show > .nav-link {
  color: #223035;
  background-color: #fff;
  border-color: #223035 #223035 #fff;
  border-top: 3px solid #223035;
}

.nav-tabs-secondary.nav-tabs {
  border-bottom: 1px solid #75808a;
}
.nav-tabs-secondary .nav-link.active,
.nav-tabs-secondary .nav-item.show > .nav-link {
  color: #75808a;
  background-color: #fff;
  border-color: #75808a #75808a #fff;
  border-top: 3px solid #75808a;
}

.tabs-vertical .nav-tabs .nav-link {
  color: #223035;
  font-size: 12px;
  text-align: center;
  letter-spacing: 1px;
  font-weight: 600;
  margin: 2px;
  margin-right: -1px;
  padding: 12px 1px;
  text-transform: uppercase;
  border: 1px solid transparent;
  border-radius: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #dee2e6;
}

.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  border-bottom: 1px solid #dee2e6;
  border-right: 0;
  border-left: 1px solid #dee2e6;
}

.tabs-vertical-primary.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #008cff;
}

.tabs-vertical-primary.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical-primary.tabs-vertical .nav-tabs .nav-link.active {
  color: #008cff;
  background-color: #fff;
  border-color: #008cff #008cff #fff;
  border-bottom: 1px solid #008cff;
  border-right: 0;
  border-left: 3px solid #008cff;
}

.tabs-vertical-success.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #15ca20;
}

.tabs-vertical-success.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical-success.tabs-vertical .nav-tabs .nav-link.active {
  color: #15ca20;
  background-color: #fff;
  border-color: #15ca20 #15ca20 #fff;
  border-bottom: 1px solid #15ca20;
  border-right: 0;
  border-left: 3px solid #15ca20;
}

.tabs-vertical-info.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #0dceec;
}

.tabs-vertical-info.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical-info.tabs-vertical .nav-tabs .nav-link.active {
  color: #0dceec;
  background-color: #fff;
  border-color: #0dceec #0dceec #fff;
  border-bottom: 1px solid #0dceec;
  border-right: 0;
  border-left: 3px solid #0dceec;
}

.tabs-vertical-danger.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #fd3550;
}

.tabs-vertical-danger.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical-danger.tabs-vertical .nav-tabs .nav-link.active {
  color: #fd3550;
  background-color: #fff;
  border-color: #fd3550 #fd3550 #fff;
  border-bottom: 1px solid #fd3550;
  border-right: 0;
  border-left: 3px solid #fd3550;
}

.tabs-vertical-warning.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #ff9700;
}

.tabs-vertical-warning.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical-warning.tabs-vertical .nav-tabs .nav-link.active {
  color: #ff9700;
  background-color: #fff;
  border-color: #ff9700 #ff9700 #fff;
  border-bottom: 1px solid #ff9700;
  border-right: 0;
  border-left: 3px solid #ff9700;
}

.tabs-vertical-dark.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #223035;
}

.tabs-vertical-dark.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical-dark.tabs-vertical .nav-tabs .nav-link.active {
  color: #223035;
  background-color: #fff;
  border-color: #223035 #223035 #fff;
  border-bottom: 1px solid #223035;
  border-right: 0;
  border-left: 3px solid #223035;
}

.tabs-vertical-secondary.tabs-vertical .nav-tabs {
  border: 0;
  border-right: 1px solid #75808a;
}

.tabs-vertical-secondary.tabs-vertical .nav-tabs .nav-item.show .nav-link,
.tabs-vertical-secondary.tabs-vertical .nav-tabs .nav-link.active {
  color: #75808a;
  background-color: #fff;
  border-color: #75808a #75808a #fff;
  border-bottom: 1px solid #75808a;
  border-right: 0;
  border-left: 3px solid #75808a;
}

.nav-pills .nav-link {
  border-radius: 0.25rem;
  color: #223035;
  font-size: 12px;
  text-align: center;
  letter-spacing: 1px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 3px;
  padding: 12px 20px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.nav-pills .nav-link:hover {
  background-color: #f4f5fa;
}

.nav-pills .nav-link i {
  margin-right: 2px;
  font-weight: 600;
}

.top-icon.nav-pills .nav-link i {
  margin: 0px;
  font-weight: 500;
  display: block;
  font-size: 20px;
  padding: 5px 0;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #008cff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(0, 140, 255, 0.5);
}

.nav-pills-success .nav-link.active,
.nav-pills-success .show > .nav-link {
  color: #fff;
  background-color: #15ca20;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(21, 202, 32, 0.5);
}

.nav-pills-info .nav-link.active,
.nav-pills-info .show > .nav-link {
  color: #fff;
  background-color: #0dceec;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(13, 206, 236, 0.5);
}

.nav-pills-danger .nav-link.active,
.nav-pills-danger .show > .nav-link {
  color: #fff;
  background-color: #fd3550;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(253, 53, 80, 0.5);
}

.nav-pills-warning .nav-link.active,
.nav-pills-warning .show > .nav-link {
  color: #fff;
  background-color: #ff9700;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(255, 151, 0, 0.5);
}

.nav-pills-dark .nav-link.active,
.nav-pills-dark .show > .nav-link {
  color: #fff;
  background-color: #223035;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(34, 48, 53, 0.5);
}

.nav-pills-secondary .nav-link.active,
.nav-pills-secondary .show > .nav-link {
  color: #fff;
  background-color: #75808a;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(117, 128, 138, 0.5);
}
.card .tab-content {
  padding: 1rem 0 0 0;
}

.z-depth-3 {
  -webkit-box-shadow: 0 11px 7px 0 rgba(0, 0, 0, 0.19),
    0 13px 25px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 11px 7px 0 rgba(0, 0, 0, 0.19), 0 13px 25px 0 rgba(0, 0, 0, 0.3);
}
</style>
